export const NO_REPORT_LOGOS_PLACEHOLDER = {
    id: -1,
};

type ReportLogoLike = {
    id: string | number;
};

export const isNoReportLogosPlaceholder = (logo: ReportLogoLike): boolean =>
    String(logo.id) === String(NO_REPORT_LOGOS_PLACEHOLDER.id);
